import PageLoadingIndicator from '../components/loading-indicators/page';
import PropTypes from 'prop-types';
import React from 'react';

//

function ChromelessLayout({ children }) {
  return (
    <>
      <main className="main-content main-content--chromeless" id="main-content">
        {children}
      </main>
      <PageLoadingIndicator />
    </>
  );
}

ChromelessLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

// Exports
// -------

export default ChromelessLayout;
